<div  *ngIf="data.type == 'success'">
    <i class="fa fa-check toast-icon success-toast" aria-hidden="true"></i> <span class="success-toast toast-hdr large-text-bold">Success!</span>
    <span class="toast-message large-text">
        {{data.message}}
    </span>
</div>

<div  *ngIf="data.type == 'error'">
    <i class="fa fa-times toast-icon error-toast" aria-hidden="true"></i>  <span class="error-toast toast-hdr large-text-bold">Error!</span>
    <span class="toast-message large-text">
        {{data.message}}
    </span>
</div>

<div  *ngIf="data.type == 'warning'">
    <i class="fa fa-exclamation-triangle toast-icon warning-toast" aria-hidden="true"></i>  <span class="warning-toast toast-hdr large-text-bold">Warning!</span>
    <span class="toast-message large-text">
        {{data.message}}
    </span>
</div>

<div  *ngIf="data.type == 'info'">
    <i class="fa fa-info-circle toast-icon info-toast" aria-hidden="true"></i>  <span class="info-toast toast-hdr large-text-bold">Info</span>
    <span class="toast-message large-text">
        {{data.message}}
    </span>
</div>